import { supabase } from './authService';
import { QuizQuestionDB } from '../types';

export const footyMasterService = {
    async getQuizzes(category?: string): Promise<QuizQuestionDB[]> {
        let query = supabase.from('footy_master_quizzes').select('*');
        if (category) {
            query = query.eq('category', category);
        }
        const { data, error } = await query.order('created_at', { ascending: false });
        if (error) throw error;
        return data || [];
    },

    async getRandomQuizzes(category?: string, count: number = 10): Promise<QuizQuestionDB[]> {
        let query = supabase.from('footy_master_quizzes').select('*');
        
        if (category) {
            query = query.eq('category', category);
        }
        
        const { data, error } = await query;
        
        if (error) throw error;
        if (!data) return [];

        return data.sort(() => Math.random() - 0.5).slice(0, count);
    },

    async createQuiz(quiz: Omit<QuizQuestionDB, 'id' | 'created_at'>): Promise<QuizQuestionDB> {
        const { data, error } = await supabase
            .from('footy_master_quizzes')
            .insert(quiz)
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async updateQuiz(id: string, quiz: Partial<QuizQuestionDB>): Promise<QuizQuestionDB> {
        const { data, error } = await supabase
            .from('footy_master_quizzes')
            .update(quiz)
            .eq('id', id)
            .select()
            .single();
        if (error) throw error;
        return data;
    },

    async deleteQuiz(id: string): Promise<void> {
        const { error } = await supabase
            .from('footy_master_quizzes')
            .delete()
            .eq('id', id);
        if (error) throw error;
    }
};
